"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorEvent = exports.SHARED_PROPS = void 0;
exports.SHARED_PROPS = {
    'Funnel Type': 'Classic',
    'Orderpipe Version': 'New',
    'Orderpipe Test Eligible': true,
};
const getError = (error, statusText, status) => {
    var _a, _b;
    if (status === 401)
        return 'Unauthorized';
    return (_b = (_a = error.error_code) !== null && _a !== void 0 ? _a : statusText) !== null && _b !== void 0 ? _b : status;
};
// When a user displays an error
const getErrorEvent = (error, statusText, status) => [
    'Orderpipe Error',
    Object.assign(Object.assign({}, exports.SHARED_PROPS), { 
        //'Page Name': getPage(store, isNewItem), // TODO(fernando.cervera): find a better way to link errors to 'pages'
        'Error Name': getError(error, statusText, status) }),
];
exports.getErrorEvent = getErrorEvent;
